<div class="p-2">

    <!-- Title -->
    <div class="row pb-2">
        <div class="col-6 h5 text-muted p-0">TCB Coupons</div>
        <div class="col-6 p-0"></div>
    </div>

    <div class="row bg-light">
        <div class="col-12 p-2">

            <!-- Filters -->
            <div class="row bg-white m-0">
                <div class="col-12">
                    <div class="row mt-2 mb-2">
                        <div class="col-12 metadata_status_button_group">
                            <div class="btn-group float-end">
                                <label [class]="metadataStatus === 0 ? 'btn btn-outline-secondary active' : 'btn btn-outline-secondary'" btnRadio="0" tabindex="0" role="button" (click)="onMetadataStatusChange(0)">Without Metadata</label>
                                <label [class]="metadataStatus === 1 ? 'btn btn-outline-secondary active' : 'btn btn-outline-secondary'" btnRadio="1" tabindex="0" role="button" (click)="onMetadataStatusChange(1)">Updated</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Coupons -->
            <div class="row mt-4 pt-4 mb-4 pb-4 text-center" *ngIf="couponsLoading === true">
                <div class="col-12">
                    <div class="spinner-border text-info  mt-4" role="status"></div>
                </div>
            </div>

            <div class="row mt-2 pt-2 pb-4">
                <div class="col-12">

                    <div class="row text-center mt-4 mb-4" *ngIf="couponsLoading == false && coupons.length == 0">
                        <i-bs class="text-black-50 mt-4 pt-4" name="tags" width="30" height="30"></i-bs>
                        <div class="col-12 mb-4 pb-4 text-black-50">TCB coupons not found</div>
                    </div>
                    
                    <div class="row" *ngIf="coupons.length > 0">
                        <div class="col-5">
                          <!-- Display Type -->
                          <span style="margin-left: 10px;">
                            <i-bs [class]="displayType == 'grid' ? 'text-secondary' : 'text-black-50 cursor-pointer'" name="grid" width="20" height="20" title="Grid view" (click)="changeDisplayType('grid')"></i-bs>
                            <i-bs [class]="displayType == 'list' ? 'text-secondary' : 'text-black-50 cursor-pointer'" style="margin-left: 10px;" name="list" width="20" height="40" title="List view" (click)="changeDisplayType('list')"></i-bs>
                          </span>
                        </div>
                        <div class="col-7">
                          <!-- Pagination Top -->
                          <pagination-controls class="float-end" style="font-size:12px" maxSize="4" autoHide="true" previousLabel=""
                            nextLabel="" (pageChange)="onCouponsPageChange($event)"></pagination-controls>
                        </div>
                    </div>

                    <!-- Grid -->
                    <div class="row" *ngIf="couponsLoading === false && coupons.length > 0 && displayType == 'grid'">
                        <div class="col-12 col-md-4 mb-3" *ngFor="let coupon of coupons | paginate: { itemsPerPage: 9, currentPage: couponsPage, totalItems: couponsCount }; let i = index;">
                            <app-show-tcb-coupon [couponListData]="coupons" [couponData]="coupon" [displayType]="displayType" (addMetadata)="onAddMetadata($event)">
                            </app-show-tcb-coupon>
                        </div>
                    </div>

                    <!-- List -->
                    <div class="row" *ngIf="couponsLoading === false && coupons.length > 0 && displayType == 'list'">
                        <div class="col-12" *ngFor="let coupon of coupons | paginate: { itemsPerPage: 9, currentPage: couponsPage, totalItems: couponsCount }; let i = index;">
                            <app-show-tcb-coupon [couponListData]="coupons" [couponData]="coupons[0]" [displayType]="displayType" (addMetadata)="onAddMetadata($event)" *ngIf="i == 0">
                            </app-show-tcb-coupon>
                        </div>
                    </div>

                    <!-- Pagination Bottom -->
                    <div class="row mt-2">
                        <div class="col-12">
                            <pagination-controls class="float-end" style="font-size:12px" maxSize="4" autoHide="true" previousLabel=""
                            nextLabel="" (pageChange)="onCouponsPageChange($event)" *ngIf="couponsCount > 0"></pagination-controls>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>

</div>